import React from 'react';
import PropTypes from 'prop-types';

const AgreementsInformationSubmit = (props) => {
  const { isTseu } = props;
  return (
    <div className="row">
      <div className="col col-md-12">
        <p>
          {!isTseu &&
            <strong>
              By clicking “Submit,” I (we) understand I (we) will submit this account
              application, agree to electronic delivery, and submit my
              electronically-signed agreement, confirming that I have read,
              understood, and acknowledge the important information provided herein.
            </strong>
          }
          {isTseu &&
            <strong>
              By clicking the “I Agree” button, I submit this account application and
              confirm that I have read, understand and agree to each of the applicable
              agreements, acknowledgments, representations, warranties, notices, disclaimers
              and assumptions of risk contained in this application and any of the foregoing documents,
              and I acknowledge that clicking the “I Agree” button constitutes an electronic signature as
              mentioned in article 3:15a of the Dutch Civil Code and Regulation (EU) no. 910/2014 of the
              European Parliament and of the Council of 23 July 2014 (Regulation on electronic
              identification and trust services) and has the same legal rights as a handwritten signature.
            </strong>
          }
        </p>
      </div>
    </div>
  );
};

AgreementsInformationSubmit.propTypes = {
  isTseu: PropTypes.bool,
};

export default AgreementsInformationSubmit;
